import React from 'react'
import PropTypes from 'prop-types'
import * as impersonationService from '../services/impersonations'
import './ImpersonationControls.css'

const ImpersonationControls = ({ impersonation, gameId, onStopImpersonation }) => {
  if (!impersonation || !impersonation.is_impersonating) {
    return null
  }

  const handleStopImpersonation = async () => {
    try {
      await impersonationService.destroy(gameId)
      if (onStopImpersonation) {
        onStopImpersonation()
      } else {
        // Default behavior: redirect to games list since user may not have access to current game
        window.location.href = '/games'
      }
    } catch (error) {
      console.error('Error stopping impersonation:', error)
      alert('Failed to stop impersonation. Please try again.')
    }
  }

  return (
    <div className="ImpersonationControls">
      <div className="ImpersonationControls__banner">
        <span className="ImpersonationControls__icon">🔍</span>
        <span className="ImpersonationControls__text">
          Currently impersonating: <strong>{impersonation.impersonated_user.username}</strong>
        </span>
        <button
          className="ImpersonationControls__stopButton"
          onClick={handleStopImpersonation}
        >
          Stop Impersonating
        </button>
      </div>
    </div>
  )
}

ImpersonationControls.propTypes = {
  impersonation: PropTypes.shape({
    is_impersonating: PropTypes.bool,
    impersonated_user: PropTypes.shape({
      username: PropTypes.string.isRequired
    })
  }),
  gameId: PropTypes.number.isRequired,
  onStopImpersonation: PropTypes.func
}

export default ImpersonationControls